package com.eladfinish.bible.contest.screens.browse.tableOfContents.ui

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.chapter_complete_reset
import com.eladfinish.bible.contest.create_completions
import com.eladfinish.bible.contest.full_pasuk
import com.eladfinish.bible.contest.half_pasuk
import com.eladfinish.bible.contest.lexicographically
import com.eladfinish.bible.contest.missing_words
import com.eladfinish.bible.contest.reyshot
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.CompleteType
import com.eladfinish.bible.contest.seyfot
import com.eladfinish.bible.contest.shuffle_verses
import com.eladfinish.bible.contest.single_word
import kotlinx.collections.immutable.toImmutableList

@Composable
internal fun ExposureTypesRow(
    onTypeClick: (CompleteType) -> Unit,
    modifier: Modifier = Modifier,
) {
    val labels = listOf(
        SharedRes.strings.shuffle_verses to CompleteType.SHUFFLE_VERSES,
        SharedRes.strings.full_pasuk to CompleteType.NEXT_EXPOSURE_VERSE,
        SharedRes.strings.half_pasuk to CompleteType.NEXT_EXPOSURE_HALF,
        SharedRes.strings.single_word to CompleteType.NEXT_EXPOSURE_WORD,
        SharedRes.strings.reyshot to CompleteType.REYSHOT_EXPOSURE,
        SharedRes.strings.seyfot to CompleteType.SEYFOT_EXPOSURE,
        SharedRes.strings.missing_words to CompleteType.PARTIALLY_EXPOSURE,
        SharedRes.strings.create_completions to CompleteType.CREATE_COMPLETIONS,
        SharedRes.strings.lexicographically to CompleteType.LEXICOGRAPHICALLY_SORTING,
    ).plus(
        listOf(
            SharedRes.strings.chapter_complete_reset to CompleteType.RESET,
        )
    ).toImmutableList()

    ButtonsInRow(
        modifier = modifier,
        labels = labels,
        onButtonCLick = onTypeClick,
    )
}
